import React from "react";
import images from "../../../constant/images";
import { Nav } from "../../../layouts/navbar/nav";
import Sidebar from "../../../layouts/sidebar/sidebar";
import { MdNotificationsActive } from "react-icons/md";
import { useTranslation } from "react-i18next";

export default function EmptyNotif() {
  const { i18n, t } = useTranslation();
    const changeLanguage = (lng) => {
      i18n.changeLanguage(lng);
    };
  return (
    
          <div className="bg-white shadow-custom bg-opacity-[87%] h-full flex flex-col justify-start items-center p-6 md:p-16 gap-4 md:gap-8 w-full md:w-[100%] rounded-3xl py-8 md:py-12">
            <div className="text-center text-3xl md:text-4xl font-bold mb-4 md:mb-6">
              <p>Notifications</p>
            </div>
            <div className="text-center justify-center items-center flex flex-col gap-3 md:gap-4 leading-relaxed md:leading-loose">
              <MdNotificationsActive size={100} className="md:size-[200px]" />
              <div className="text-xl md:text-3xl font-semibold">
              {t("EmptyNotif.no_notifications")}

              </div>
              <div className="text-base md:text-xl text-center">
              {t("EmptyNotif.p1")}{" "}
                <br className="hidden md:block" /> {t("EmptyNotif.p2")}
              </div>
            </div>
          </div>
       
  );
}
